export { default } from "./CascadingMenu.js";
